import { getAviosBaseUrl } from '@reward-platform/platform-config'

const externalAncillaryPaths: Partial<Record<string, string>> = {
  hotels: '/hotels',
  cars: '/cars',
  carhire: '/cars',
  experiences: '/experiences',
}

export const shouldUseAerLingusExternalAncillaryLinks = (
  isFeatureEnabled: boolean,
  opCo: string,
  buildType: string
) => isFeatureEnabled && opCo === 'EI' && buildType === 'whitelabel'

export const getExternalAncillaryUrl = (slug: string | undefined, locale: string) => {
  const path = slug ? externalAncillaryPaths[slug] : undefined

  return path ? `${getAviosBaseUrl(locale)}${path}?opco=EI` : undefined
}
